import { StockBalancesMainContainer } from '@/modules/StockBalances';

const StockBalancesPage = (): JSX.Element => <StockBalancesMainContainer />;

export default StockBalancesPage;
